/**
 * Delivery estimate timeline: date ranges are computed client-side from
 * data-delivery-range="min,max" business-day offsets, so cached pages always show the
 * estimate relative to the viewing date instead of the render date.
 */
window.theme = window.theme || {};

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

function formatDate(date) {
  return `${MONTHS[date.getMonth()]} ${date.getDate()}`;
}

function addBusinessDays(date, days) {
  const result = new Date(date);
  for (let remaining = Math.max(0, days); remaining > 0;) {
    result.setDate(result.getDate() + 1);
    if (result.getDay() !== 0 && result.getDay() !== 6) remaining -= 1;
  }
  return result;
}

function rangeLabel(minDays, maxDays) {
  const today = new Date();
  const from = addBusinessDays(today, minDays);
  const to = addBusinessDays(today, maxDays);
  // same-month ranges collapse the month, e.g. "Sep 20–27" (matches %b %-d)
  return from.getFullYear() === to.getFullYear() && from.getMonth() === to.getMonth()
    ? `${formatDate(from)}–${to.getDate()}`
    : `${formatDate(from)}–${formatDate(to)}`;
}

function renderDeliveryRanges(root = document) {
  root.querySelectorAll("[data-delivery-range]").forEach((el) => {
    const [min, max] = el.dataset.deliveryRange.split(",").map((n) => Number.parseInt(n, 10));
    if (Number.isFinite(min) && Number.isFinite(max)) el.textContent = rangeLabel(min, max);
  });
}

window.theme.renderDeliveryRanges = renderDeliveryRanges;
renderDeliveryRanges();
